import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";
import { useSettings } from "@/lib/hooks";
import Logo from "@/components/Logo";

export default function Footer() {
  const s = useSettings();
  return (
    <footer className="bg-ink-900 text-white pt-14 pb-24 lg:pb-10" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 lg:px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          <div>
            <Logo tone="light" className="h-10" />
            <p className="text-ink-300 text-sm mt-4 max-w-xs leading-relaxed">
              Votre partenaire de confiance pour tous vos dépannages, remorquages et transports de véhicules en Île-de-France.
            </p>
          </div>

          <FCol title="Liens rapides">
            <FLink to="/">Accueil</FLink>
            <FLink to="/services">Nos Services</FLink>
            <FLink to="/tarifs">Tarifs</FLink>
            <FLink to="/zones">Zones d'intervention</FLink>
            <FLink to="/avis">Avis Clients</FLink>
            <FLink to="/contact">Contact</FLink>
          </FCol>

          <FCol title="Services">
            <FLink to="/services/depannage-voiture">Dépannage</FLink>
            <FLink to="/services/remorquage-voiture">Remorquage</FLink>
            <FLink to="/services/transport-vehicule">Transport</FLink>
            <FLink to="/services/assistance-routiere">Assistance routière</FLink>
            <FLink to="/services/rachat-epave">Rachat épave</FLink>
          </FCol>

          <FCol title="Contact">
            <a href={`tel:${s?.company_phone_raw || ""}`} className="flex items-center gap-2 text-ink-200 hover:text-white transition-colors">
              <Phone size={14} />{s?.company_phone || "07 53 95 58 90"}
            </a>
            <a href={`mailto:${s?.company_email || ""}`} className="flex items-center gap-2 text-ink-200 hover:text-white transition-colors">
              <Mail size={14} />{s?.company_email || "Contact.depannidf@gmail.com"}
            </a>
            <div className="flex items-center gap-2 text-ink-200">
              <Clock size={14} />
              <span>24h/24 - 7j/7</span>
            </div>
          </FCol>
        </div>

        <div className="border-t border-ink-700 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-ink-400 text-xs">
          <div>&copy; {new Date().getFullYear()} Depann7 — Tous droits réservés</div>
          <div className="flex gap-5">
            <Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-white transition-colors">Confidentialité</Link>
            <Link to="/cgv" className="hover:text-white transition-colors">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FCol({ title, children }) {
  return (
    <div>
      <div className="text-sm font-bold uppercase tracking-wider text-white mb-4">{title}</div>
      <div className="flex flex-col gap-2 text-sm text-ink-200">{children}</div>
    </div>
  );
}
function FLink({ to, children }) {
  return <Link to={to} className="hover:text-white transition-colors">{children}</Link>;
}
